import darkLogo from '@/assets/img/svg/dark-logo-by-wake.svg'
import lightLogo from '@/assets/img/svg/light-logo-by-wake.svg'
import MySquid from '@interfaces/my-squid.interface'
import onConfigChange from '@observables/config.obvervable'
import React, { useEffect, useRef, useState } from 'react'
import { Subscription } from 'rxjs'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  forceSquid?: boolean
  forceDark?: boolean
  forceLight?: boolean
  width?: string
  height?: string
  styleImg?: any
}

export default ({
  className = '',
  forceDark,
  forceLight,
  width = '100%',
  height = '',
  style = { maxWidth: '75px' },
  styleImg,
  id = '',
}: Props) => {
  const onConfigChangeSubscription = useRef<Subscription>(undefined)
  const [configs, setConfig] = useState<MySquid>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    onConfigChangeSubscription.current = onConfigChange.subscribe((configChanged: MySquid) => {
      if (configChanged?._id) {
        setConfig(configChanged)
      }
      setLoading(false)
    })
    return () => {
      onConfigChangeSubscription?.current?.unsubscribe()
    }
  }, [onConfigChangeSubscription])

  if (loading) {
    return null
  }

  return (
    <figure className={className} id={id} style={style}>
      <img
        width={width}
        height={height}
        src={lightLogo}
        alt="Logo by Wake"
        title="Wake"
        className={`img-fluid normal ${forceLight ? 'display-inline-block' : ''}`}
        style={{
          width: width,
          height: height,
          ...styleImg,
        }}
      />
      <img
        width={width}
        height={height}
        src={darkLogo}
        alt="Logo by Wake"
        title="Wake"
        className={`img-fluid negative ${forceDark ? 'display-inline-block' : ''}`}
        style={{
          width: width,
          height: height,
          ...styleImg,
        }}
      />
    </figure>
  )
}
